import React from 'react'
import img from "./Components/AboutMe.jpg"
import './App.css'

const Presentation = (props) => {

       let name = "Carolina A. Moller";
       let seniority = "";
       let skills = "HTML, CSS, JS, React";
       let coursesButton = "";
       let contactMeButton = "";
       let aboutMeButton = "";

       if (props.language === "English"){
           //console.log("esoy leyendo el if de presentation")
            seniority = "Front End Developer Jr.";
            coursesButton = "My certifications";
            contactMeButton = "Contact";
            aboutMeButton = "About Me";
       } else if (props.language === "Spanish"){
            seniority = "Desarrolladora Front End Jr.";
            coursesButton = "Mis certificaciones";
            contactMeButton = "Contacto";
            aboutMeButton = "Sobre Mí";
       } 

    /*    console.log(name);
       console.log(seniority);
       console.log(skills); */

    

        return (
            <div className='Presentation'>
                <h2 id="Name">{name}</h2>
                <h1 id="Seniority">{seniority}</h1>
                <h2 id="Skills">{skills}</h2>
               
                <img id="imgOfCM" src={img} alt="Carolina Moller"></img>
                

                <button type="button" className="btn btn-outline-light" onClick={props.aboutMe} >{aboutMeButton}</button><br></br>

                <button type="button" className="btn btn-outline-primary" onClick={props.certif}>{coursesButton}</button><br></br>

                <button type="button" className="btn btn-outline-light" onClick={props.contactMe} >{contactMeButton}</button>
            </div>
        )
} 


export default Presentation
